module.exports = __webpack_public_path__ + "img/yuangong4.6f0ecaec.jpg";